import axios from 'axios';

const API_URL = '/projects';

/**
 * Get all projects
 */
const getProjects = async (params = {}) => {
  const response = await axios.get(`${API_URL}/`, { params });
  return response.data;
};

/**
 * Get project by ID
 */
const getProject = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/`);
  return response.data;
};

/**
 * Create new project
 */
const createProject = async (data) => {
  const response = await axios.post(`${API_URL}/`, data);
  return response.data;
};

/**
 * Update project
 */
const updateProject = async (id, data) => {
  const response = await axios.patch(`${API_URL}/${id}/`, data);
  return response.data;
};

/**
 * Delete project
 */
const deleteProject = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}/`);
  return response.data;
};

/**
 * Assign/Remove users from project
 */
const assignUsers = async (id, data) => {
  const response = await axios.post(`${API_URL}/${id}/assign-users/`, data);
  return response.data;
};

/**
 * Get project statistics
 */
const getProjectStats = async (id) => {
  const response = await axios.get(`${API_URL}/${id}/stats/`);
  return response.data;
};

const projectService = {
  getProjects,
  getProject,
  createProject,
  updateProject,
  deleteProject,
  assignUsers,
  getProjectStats,
};

export default projectService;